export const SET_SETTINGS_LIST = 'SET_SETTINGS_LIST'
export const SET_SETTINGS_ERROR = 'SET_SETTINGS_ERROR'
export const SET_OPTIONAL_DATA = 'SET_OPTIONAL_DATA'
export const SET_SOURCE_TYPE_DETAIL_CONFIG = 'SET_SOURCE_TYPE_DETAIL_CONFIG'
export const SET_DETAIL_CONFIG_SOURCE_TYPE = 'SET_DETAIL_CONFIG_SOURCE_TYPE'
export const SET_SELECTED_DETAIL_OUTPUT = 'SET_SELECTED_DETAIL_OUTPUT'
export const SET_SETTINGS_RECORD_DETAIL_DRAWER = 'SET_SETTINGS_RECORD_DETAIL_DRAWER'
export const UPDATE_DETAIL_OUTPUT = 'UPDATE_DETAIL_OUTPUT'
export const UPDATE_HISTORY_DETAIL_OUTPUT = 'UPDATE_HISTORY_DETAIL_OUTPUT'
export const SET_SETTINGS_LOADING = 'SET_SETTINGS_LOADING'
export const SET_DETAIL_CONFIG_SUB_TYPE = 'SET_DETAIL_CONFIG_SUB_TYPE'
export const SET_PAGE_PROPERTIES = 'SET_PAGE_PROPERTIES'
export const SET_SETTINGS_FILTER_TEXT = 'SET_SETTINGS_FILTER_TEXT'
export const SET_SETTINGS_PAGE_NUM = 'SET_SETTINGS_PAGE_NUM'

export const initialState = {
  settingsList: [],
  optionalData: {},
  settingsError: null,
  filterText: '',
  pageNum: 0,
  loading: true,
  defaultDTOs: {},
  pageProperties: [],
  recordDetailConfig: {
    sourceTypeConfig: {},
    historyConfig: {},
    isDirty: false,
    sourceType: '0',
    drawerShown: false,
    selectedDetailOutput: {},
    subType: 0,
  },
}

const SettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPTIONAL_DATA: {
      return {
        ...state,
        optionalData: action.optionalData,
      }
    }
    case SET_SETTINGS_LIST: {
      return {
        ...state,
        settingsList: action.settingsList,
      }
    }
    case SET_SETTINGS_FILTER_TEXT: {
      return {
        ...state,
        filterText: action.filterText || '',
        pageNum: 0,
      }
    }
    case SET_SETTINGS_PAGE_NUM: {
      return {
        ...state,
        pageNum: action.pageNum,
      }
    }
    case SET_SETTINGS_ERROR: {
      return {
        ...state,
        settingsError: action.settingsError,
      }
    }

    case SET_SOURCE_TYPE_DETAIL_CONFIG: {
      // console.log(state.recordDetailConfig)
      return {
        ...state,
        recordDetailConfig: {
          ...state.recordDetailConfig,
          sourceTypeConfig: action.sourceTypeConfig,
          historyConfig: action.historyConfig || {},
          isDirty: !!action.isDirty,
          selectedDetailOutput: {},
        },
      }
    }
    case SET_DETAIL_CONFIG_SOURCE_TYPE: {
      return {
        ...state,
        recordDetailConfig: {
          ...state.recordDetailConfig,
          sourceType: action.sourceType,
        },
      }
    }
    case SET_DETAIL_CONFIG_SUB_TYPE: {
      return {
        ...state,
        recordDetailConfig: {
          ...state.recordDetailConfig,
          subType: action.subType,
        },
      }
    }
    case SET_SELECTED_DETAIL_OUTPUT: {
      return {
        ...state,
        recordDetailConfig: {
          ...state.recordDetailConfig,
          selectedDetailOutput: {
            ...action,
            type: undefined,
            drawerShown: undefined,
          },
          drawerShown: action.drawerShown,
        },
      }
    }
    case SET_SETTINGS_RECORD_DETAIL_DRAWER: {
      return {
        ...state,
        recordDetailConfig: {
          ...state.recordDetailConfig,
          drawerShown: action.drawerShown,
          selectedDetailOutput: {
            ...state.recordDetailConfig.selectedDetailOutput,
            isGeneric: false,
          },
        },
      }
    }
    case UPDATE_DETAIL_OUTPUT: {
      const config = state.recordDetailConfig.sourceTypeConfig
      if (config[action.subType] && config[action.subType].FieldSettings) {
        const value = {
          ...state,
          recordDetailConfig: {
            ...state.recordDetailConfig,
            sourceTypeConfig: {
              ...config,
              [action.subType]: {
                ...config[action.subType],
                FieldSettings: {
                  ...config[action.subType].FieldSettings,
                  ...updateObject(action.accessor, action.info, {
                    ...state.recordDetailConfig.sourceTypeConfig[action.subType || 0].FieldSettings,
                  }),
                },
              },
            },
            selectedDetailOutput: {
              ...state.recordDetailConfig.selectedDetailOutput,
              info: { ...action.info },
            },
            isDirty: true,
          },
        }
        // console.log(value)
        return value
      } else if (config.FieldSettings) {
        const value = {
          ...state,
          recordDetailConfig: {
            ...state.recordDetailConfig,
            sourceTypeConfig: {
              ...config,
              FieldSettings: {
                ...config.FieldSettings,
                ...updateObject(action.accessor, action.info, {
                  ...state.recordDetailConfig.sourceTypeConfig.FieldSettings,
                }),
              },
            },
            selectedDetailOutput: {
              ...state.recordDetailConfig.selectedDetailOutput,
              info: { ...action.info },
            },
            isDirty: true,
          },
        }
        // console.log(value)
        return value
      }

      return {
        ...state,
        recordDetailConfig: {
          ...state.recordDetailConfig,
          sourceTypeConfig: {
            ...state.recordDetailConfig.sourceTypeConfig,
            [action.accessor]: {
              ...action.info,
            },
          },
          selectedDetailOutput: {
            ...state.recordDetailConfig.selectedDetailOutput,
            info: { ...action.info },
          },
          isDirty: true,
        },
      }
    }
    case UPDATE_HISTORY_DETAIL_OUTPUT: {
      const config = state.recordDetailConfig.sourceTypeConfig
      if (config[action.subType] && config[action.subType].HistoryConfig) {
        // console.log(action)
        const value = {
          ...state,
          recordDetailConfig: {
            ...state.recordDetailConfig,
            sourceTypeConfig: {
              ...config,
              [action.subType]: {
                ...config[action.subType],
                HistoryConfig: (config[action.subType].HistoryConfig || []).map((item) => {
                  if (item.id === action.accessor) {
                    return {
                      ...item,
                      enabled: action.info.enabled,
                      label: action.info.label,
                    }
                  } else if (item.Id === action.accessor) {
                    return {
                      ...item,
                      IsEnabled: action.info.IsEnabled,
                      Label: action.info.Label,
                    }
                  }
                  return item
                }),
              },
            },
            selectedDetailOutput: {
              ...state.recordDetailConfig.selectedDetailOutput,
              info: { ...action.info },
            },
            isDirty: true,
          },
        }
        // console.log(value)
        return value
      } else if (config.HistoryConfig) {
        const value = {
          ...state,
          recordDetailConfig: {
            ...state.recordDetailConfig,
            sourceTypeConfig: {
              ...config,
              HistoryConfig: (config.HistoryConfig || []).map((item) => {
                if (item.id === action.accessor) {
                    return {
                      ...item,
                      enabled: action.info.enabled,
                      label: action.info.label,
                    }
                  } else if (item.Id === action.accessor) {
                    return {
                      ...item,
                      IsEnabled: action.info.IsEnabled,
                      Label: action.info.Label,
                    }
                  }
                return item
              }),
            },
            selectedDetailOutput: {
              ...state.recordDetailConfig.selectedDetailOutput,
              info: { ...action.info },
            },
            isDirty: true,
          },
        }
        // console.log(value)
        return value
      }
      return {
        ...state,
        recordDetailConfig: {
          ...state.recordDetailConfig,
          historyConfig: {
            ...state.recordDetailConfig.historyConfig,
            [action.accessor]: {
              ...action.info,
            },
          },
          selectedDetailOutput: {
            ...state.recordDetailConfig.selectedDetailOutput,
            info: { ...action.info },
          },
          isDirty: true,
        },
      }
    }
    case SET_SETTINGS_LOADING: {
      return {
        ...state,
        loading: action.loading,
      }
    }
    case SET_PAGE_PROPERTIES: {
      return {
        ...state,
        pageProperties: action.pageProperties || [],
        defaultDTOs: {
          ...state.defaultDTOs,
          [action.pathParameter]: action.defaultDTO || {},
        },
      }
    }
    default:
      return state
  }
}

const updateObject = (keyName, newVal, object) => {
  for (var key in object) {
    if (key === keyName) {
      // console.log(key, keyName, object[key], newVal, object)
      object[key] = newVal
    } else {
      if (typeof object[key] === 'object') {
        object[key] = updateObject(keyName, newVal, object[key])
      }
    }
  }
  return object
}

export default SettingsReducer
